export const USDT_ABI = [
  'function approve(address spender, uint256 value) returns (bool)',
  'function allowance(address owner, address spender) view returns (uint256)',
  'function balanceOf(address account) view returns (uint256)',
  'function transfer(address to, uint256 value) returns (bool)',
  'function decimals() view returns (uint8)'
];

export const UVW_CORE_ABI = [
  // Registration & Activation
  'function register(uint256 referrerId)',
  'function registerMultiplePackages(uint256 referrerId, uint256 upToPackageId)',
  'function activatePackage(uint256 packageId)',
  'function activateMultiplePackages(uint256 fromPkg, uint256 toPkg)',
  'function retopup(uint256 packageId)',
  // User views
  'function walletToUserId(address wallet) view returns (uint256)',
  'function users(uint256 userId) view returns (address wallet, uint256 referrerId, uint256 joinTime, uint256 totalDirectRefs, uint256 totalIncomeEarned, uint8 userType)',
  'function isUserPackageActive(uint256 userId, uint256 packageId) view returns (bool)',
  'function getUserType(uint256 userId) view returns (uint8)',
  'function getUserWallet(uint256 userId) view returns (address)',
  'function getUserReferrerId(uint256 userId) view returns (uint256)',
  'function getDirectReferralsCount(uint256 userId) view returns (uint256)',
  'function getDirectReferralsList(uint256 userId) view returns (uint256[])',
  'function getActiveDirectsPerPackage(uint256 userId, uint256 packageId) view returns (uint256)',
  'function blockedUsers(uint256 userId) view returns (bool)',
  'function allUserIds(uint256 index) view returns (uint256)',
  'function totalUsers() view returns (uint256)',
  'function getTotalUsers() view returns (uint256)',
  'function packagePrices(uint256 index) view returns (uint256)',
  'function retopupPrices(uint256 index) view returns (uint256)',
  'function ceilingLimits(uint256 index) view returns (uint256)',
  'function defaultReferrerId() view returns (uint256)',
  'function userIncomeBreakdown(uint256 userId) view returns (uint256 boardIncome, uint256 directIncome, uint256 levelIncome, uint256 autoLevelIncome, uint256 royaltyIncome, uint256 dividendIncome)',
  'function userActivityCount(uint256 userId) view returns (uint256)',
  'function userActivityPointer(uint256 userId) view returns (uint256)',
  'function userActivities(uint256 userId, uint256 index) view returns (uint8 activityType, uint256 amount, uint256 netAmount, uint256 relatedId, uint256 timestamp)',
  'function getPackagePrices() view returns (uint256[7])',
  'function getRetopupPrices() view returns (uint256[7])',
  'function getCeilingLimits() view returns (uint256[7])',
  'function getContractBalance() view returns (uint256)',
  'function getRouterPoolBalance() view returns (uint256)',
  'function routerPool() view returns (uint256)',
  'function getDefaultReferrer() view returns (uint256, address)',
  'function checkCeilingAvailable(uint256 userId, uint256 packageId, uint256 amount) view returns (bool, uint256, uint256)',
  'function levelTeamCount(uint256 userId, uint256 level) view returns (uint256)',
  'function getLevelTeamCount(uint256 userId, uint256 level) view returns (uint256)',
  'function getLevelTeamCounts(uint256 userId) view returns (uint256[30])',
  // Owner/Admin
  'function owner() view returns (address)',
  'function admin() view returns (address)',
  'function poolsContract() view returns (address)',
  'function matrixContract() view returns (address)',
  'function adminRegisterPrivileged(address wallet, uint256 referrerId)',
  'function adminRegisterVirtual(address wallet, uint256 referrerId, uint256 upToPackageId)',
  'function blockUser(uint256 userId, bool blocked)',
  'function adminRetopup(uint256 userId, uint256 packageId)',
  'function emergencyWithdraw(uint256 amount)',
  'function claimRouterPool(uint256 amount)',
  'function setPoolsContract(address _p)',
  'function setMatrixContract(address _m)',
  'function setAdmin(address _a)',
  'function setOwner(address _o)',
  'function setTeamWallet1(address w)',
  'function setTeamWallet2(address w)',
  'function setNetworkWallet(address w)',
  'function setSalaryWallet1(address w)',
  'function setSalaryWallet2(address w)',
  'function setExpenseWallet(address w)',
  'function setRewardWallet(address w)',
  'function setRouter1Wallet(address w)',
  'function setUSDTToken(address _u)',
  'function setDefaultReferrer(uint256 _id)',
  'function teamWallet1() view returns (address)',
  'function teamWallet2() view returns (address)',
  'function networkWallet() view returns (address)',
  'function salaryWallet1() view returns (address)',
  'function salaryWallet2() view returns (address)',
  'function expenseWallet() view returns (address)',
  'function rewardWallet() view returns (address)',
  'function router1Wallet() view returns (address)',
  'function usdt() view returns (address)'
];

export const UVW_MATRIX_ABI = [
  'function getUserBoard(uint256 userId, uint256 packageId) view returns (uint256, uint256[2], uint256[4], bool, uint256)',
  'function getUserBoardRaw(uint256 userId, uint256 packageId) view returns (uint256, uint256[2], uint256[4], bool, uint256, uint256)',
  'function getBoardCycleHistory(uint256 userId, uint256 packageId) view returns (tuple(uint256 cycleNumber, uint256[2] firstLevelUsers, uint256[4] secondLevelUsers, uint256 completedAt)[])',
  'function getBoardCycleCount(uint256 userId, uint256 packageId) view returns (uint256)',
  'function owner() view returns (address)',
  'function admin() view returns (address)',
  'function coreContract() view returns (address)',
  'function setCoreContract(address _c)',
  'function setAdmin(address _a)',
  'function setOwner(address _o)'
];

export const UVW_POOLS_ABI = [
  // Claim functions
  'function claimLevelIncome(uint256 amount)',
  'function claimAutoLevelIncome(uint256 amount)',
  'function claimAllRoyalty()',
  'function claimDividend()',
  'function claimAll()',
  'function adminClaimForPrivileged(uint256[] userIds)',
  'function claimRouterDividend()',
  'function routerDividendDebt(uint256 packageId) view returns (uint256)',
  // State views
  'function autoLevelUpline(uint256 packageId, uint256 userId) view returns (uint256)',
  'function autoLevelDownline(uint256 packageId, uint256 userId, uint256 index) view returns (uint256)',
  'function autoLevelTeamSize(uint256 packageId, uint256 userId) view returns (uint256)',
  'function autoLevelCountPerLevel(uint256 packageId, uint256 userId, uint256 level) view returns (uint256)',
  'function getAutoLevelCountAtLevel(uint256 userId, uint256 packageId, uint256 level) view returns (uint256)',
  'function getAutoLevelCountAllLevels(uint256 userId, uint256 packageId) view returns (uint256[10])',
  'function claimableLevelIncome(uint256 userId, uint256 packageId) view returns (uint256)',
  'function claimableLevelIncomeTotal(uint256 userId) view returns (uint256)',
  'function claimableAutoLevelIncome(uint256 userId, uint256 packageId) view returns (uint256)',
  'function claimableAutoLevelIncomeTotal(uint256 userId) view returns (uint256)',
  // Royalty
  'function eliteRoyaltyEligible(uint256 userId) view returns (bool)',
  'function globalRoyaltyEligible(uint256 userId) view returns (bool)',
  'function eliteRoyaltyAccumulation() view returns (uint256)',
  'function globalRoyaltyAccumulation() view returns (uint256)',
  'function eliteRoyaltyEligibleCount() view returns (uint256)',
  'function globalRoyaltyEligibleCount() view returns (uint256)',
  'function currentEliteRound() view returns (uint256)',
  'function currentGlobalRound() view returns (uint256)',
  'function eliteRoundIncome(uint256 round) view returns (uint256)',
  'function globalRoundIncome(uint256 round) view returns (uint256)',
  'function userLastEliteClaim(uint256 userId) view returns (uint256)',
  'function userLastGlobalClaim(uint256 userId) view returns (uint256)',
  // Dividend
  'function dividendAccPerShare(uint256 packageId) view returns (uint256)',
  'function dividendTotalShares(uint256 packageId) view returns (uint256)',
  'function dividendTotalAccum(uint256 packageId) view returns (uint256)',
  'function userDividendDebt(uint256 packageId, uint256 userId) view returns (uint256)',
  'function userInDividend(uint256 packageId, uint256 userId) view returns (bool)',
  // Rewards
  'function rewardTierCount() view returns (uint256)',
  'function rewardTiers(uint256 tierId) view returns (string name, string description, uint256 directsRequired, uint256 levelRequired, uint256 membersRequired, bool requireFullPackages, bool active)',
  'function isUserRewardEligible(uint256 tierId, uint256 userId) view returns (bool)',
  'function isUserRewardGiven(uint256 tierId, uint256 userId) view returns (bool)',
  'function getRewardEligibleUsers(uint256 tierId) view returns (uint256[])',
  'function getRewardEligibleCount(uint256 tierId) view returns (uint256)',
  'function fullPackageDirects(uint256 userId) view returns (uint256)',
  'function fullPackageLevelCount(uint256 userId, uint256 level) view returns (uint256)',
  // Admin
  'function owner() view returns (address)',
  'function admin() view returns (address)',
  'function coreContract() view returns (address)',
  'function packagePrices(uint256 index) view returns (uint256)',
  'function retopupPrices(uint256 index) view returns (uint256)',
  'function setEliteRoundIncome(uint256 amountPerUser)',
  'function setGlobalRoundIncome(uint256 amountPerUser)',
  'function resetEliteAccumulation()',
  'function resetGlobalAccumulation()',
  'function adminSetEliteEligibility(uint256 userId, bool eligible)',
  'function adminSetGlobalEligibility(uint256 userId, bool eligible)',
  'function setRewardTier(uint256 tierId, string name, string desc, uint256 directsReq, uint256 levelReq, uint256 membersReq, bool fullPkgs, bool active)',
  'function setRewardTierActive(uint256 tierId, bool active)',
  'function markRewardGiven(uint256 tierId, uint256 userId)',
  'function setCoreContract(address _c)',
  'function setAdmin(address _a)',
  'function setOwner(address _o)'
];

export const UVW_VIEWS_ABI = [
  'function getUserInfo(uint256 userId) view returns (address wallet, uint256 referrerId, uint256 joinTime, bool[7] packageActive, uint256 totalDirectRefs, uint256 totalIncomeEarned, uint8 userType, bool blocked)',
  'function getUserIncomeBreakdown(uint256 userId) view returns (uint256 boardIncome, uint256 directIncome, uint256 levelIncome, uint256 autoLevelIncome, uint256 royaltyIncome, uint256 dividendIncome)',
  'function getUserDashboard(uint256 userId) view returns (uint256 totalIncome, uint256 claimableLevel, uint256 claimableAutoLevel, uint256 claimableElite, uint256 claimableGlobal, uint256 claimableDividend, bool eliteEligible, bool globalEligible)',
  'function getUserIdsByRange(uint256 offset, uint256 limit) view returns (uint256[] userIds, uint256 total)',
  'function getUserActivities(uint256 userId, uint256 offset, uint256 limit) view returns (uint8[] types, uint256[] amounts, uint256[] timestamps, uint256 total)',
  'function getLevelIncomeLevelCounts(uint256 userId) view returns (uint256[30])',
  'function getAutoLevelLevelCounts(uint256 userId, uint256 packageId) view returns (uint256[10])',
  'function getAutoLevelInfo(uint256 userId, uint256 packageId) view returns (uint256 upline, uint256[] downlines, uint256 teamSize)',
  'function getClaimableLevelIncome(uint256 userId) view returns (uint256[7] perPackage, uint256 total)',
  'function getClaimableAutoLevelIncome(uint256 userId) view returns (uint256[7] perPackage, uint256 total)',
  'function getUserRoyaltyEligibility(uint256 userId) view returns (bool elite, bool global)',
  'function getUserClaimableElite(uint256 userId) view returns (uint256 total)',
  'function getUserClaimableGlobal(uint256 userId) view returns (uint256 total)',
  'function getUserDividendInfo(uint256 userId) view returns (uint256[7] pending, uint256 totalPending)',
  'function getDividendPoolInfo() view returns (uint256[7] totalAccum, uint256[7] totalShares, uint256[7] accPerShare)',
  'function getRewardEligibleUsers(uint256 tierId) view returns (uint256[])',
  'function getRewardEligibleCount(uint256 tierId) view returns (uint256)',
  'function getUserRewardStatus(uint256 userId) view returns (bool[] eligible, bool[] given)',
  'function getUserRewardCounters(uint256 userId) view returns (uint256 fpDirects, uint256[5] fpLevelCounts)',
  'function owner() view returns (address)',
  'function coreContract() view returns (address)',
  'function poolsContract() view returns (address)',
  'function setCoreContract(address _c)',
  'function setPoolsContract(address _p)',
  'function setOwner(address _o)'
];
